export const CAROUSEL_LINK = [
  {
    path: "https://runner-web.surge.sh/static/media/slide2.094dfa5e.jpg",
  },
  {
    path: "https://runner-web.surge.sh/static/media/slide3.d8ec659d.png",
  },
  {
    path: "https://runner-web.surge.sh/static/media/slide4.fca25a5e.png",
  },
];
